module.exports = __webpack_public_path__ + "static/img/4_bc_coors-i.cafd93e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4_bc_coors-i.png
// module id = e1SF
// module chunks = 0